import { toast } from 'react-toastify';

const options = {
  autoClose: 50000,
  hideProgressBar: true,
  position: toast.POSITION.TOP_RIGHT,
};

type ToastType = {
  message: string;
  autoClose?: number | false;
  toastId?: number;
  closeOnClick?: boolean;
};

export const showSuccessToast = ({ message, autoClose }: ToastType): void => {
  toast.success(message, {
    ...options,
    autoClose: autoClose !== undefined ? autoClose : 5000,
    closeOnClick: true,
  });
};

export const showErrorToast = ({
  message,
  autoClose,
  toastId,
}: ToastType): void => {
  if (toastId) {
    const activeId = toast.isActive(toastId);
    if (activeId) return;
  }
  toast.error(message, {
    ...options,
    autoClose: autoClose !== undefined ? autoClose : 5000,
    toastId,
    closeOnClick: true,
  });
};

export const showInfoToast = ({ message, autoClose }: ToastType): void => {
  toast.info(message, {
    ...options,
    autoClose: autoClose !== undefined ? autoClose : 5000,
    closeOnClick: true,
  });
};

export const showWarningToast = ({ message, autoClose }: ToastType): void => {
  toast.warning(message, {
    ...options,
    autoClose: autoClose !== undefined ? autoClose : 5000,
    closeOnClick: true,
  });
};
